import Api from 'api/v2/Api';

const basePath = '/api/v2/certificates';

// @todo: These methods will likely change with the API definition
export class PkiApi extends Api {
  enable(groupType, groupIds, certificateLength) {
    return this.axios.post(`${basePath}/enable`, {
      certificateLength,
      groupIds,
      groupType,
    });
  }

  fetchById(id) {
    return this.axios.get(`${basePath}/${id}`);
  }

  fetchByParams({
    filter = '',
    skip = 0,
    limit = 100,
    sortBy = '',
    sortDir = 'desc',
  } = {}) {
    // @todo: filter mapping
    const params = new URLSearchParams({
      filter,
      skip,
      limit,
      sortBy,
      sortDir,
    }).toString();

    return this.axios.get(`${basePath}?${params}`);
  }

  revokeById(id) {
    return this.axios.post(`${basePath}/revoke?ids=${id}`);
  }

  revokeAll(ids) {
    return this.axios.post(`${basePath}/revoke?ids=${ids.join(',')}`);
  }

  revokeByGroupType(groupType) {
    return this.axios.post(`${basePath}/revoke?groupType=${groupType}`);
  }
}

export default new PkiApi();
